import React from 'react';
import { Link } from 'react-router';

import { helpCenterRoute, termsRoute } from '~/routes';

const linkStyles = {
  color: 'var(--secondary-dark-color)',
  textDecoration: 'underline',
};

const TermsConsent = ({ textBlocks, buttonText = 'submit order' }) => {
  return (
    <p>
      By clicking "{buttonText}" you agree to our{' '}
      <Link style={linkStyles} to={termsRoute()}>
        Terms of Use
      </Link>{' '}
      and <a href={window.env.PRIVACY_POLICY_URL}>Privacy Policy</a>.{' '}
      {textBlocks?.filter(Boolean)?.join(' ')}&nbsp;
      <a
        href={helpCenterRoute({
          a: 'Cancellation-policy---id--Xz6AjrPLQ12fcVhQ570E2Q',
        })}
        target="_blank"
        rel="noreferrer"
        style={linkStyles}
      >
        Cancel anytime
      </a>
      .
    </p>
  );
};

export default TermsConsent;
